/**
 * @voltxampere/ui — PNP BJT (PNP)
 *
 * Same encapsulation geometry as the NPN, but the polarity arrow
 * sits near the base end of the body line and points INWARD (toward
 * the base). Per Zenit §1.3: emitter is the top-right terminal,
 * collector is bottom-right.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_IVORY, STROKE_WIDTH_HEAVY, STROKE_WIDTH_MAIN, VIEWBOX_DEFAULT, } from "./constants.js";
export const pnp = {
    id: "pnp",
    nameTr: "PNP",
    nameEn: "PNP BJT",
    shortcut: "⇧Q",
    category: "active",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 10, y: 13, label: "B", polarity: "out" },
        { x: 32, y: 4, label: "E", polarity: "in" },
        { x: 32, y: 22, label: "C", polarity: "out" },
    ],
    defaultLabel: "Q",
    renderSVG: () => [
        `<circle cx="22" cy="13" r="10" fill="none" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="16" y1="7" x2="16" y2="19" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_HEAVY)}"/>`,
        `<line x1="10" y1="13" x2="16" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="16" y1="10" x2="28" y2="4" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="28" y1="4" x2="32" y2="4" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="16" y1="16" x2="28" y2="22" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="28" y1="22" x2="32" y2="22" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<polygon points="18,11 14,13 18,15" fill="${STROKE_IVORY}"/>`,
    ].join(""),
};
//# sourceMappingURL=pnp.js.map